const INITIAL_STATE = {
    dadosConcal: {},
    beneficioSelecionado: null,
    mensagem:'',
    esperandoRespostaSolicitacao: false,
    erro: false,
    error_elo: false
};

export default (state= INITIAL_STATE, action) =>{
    switch(action.type){

        case 'CONCAL_DADOS_SOLICITADO':
            return {...state, esperandoRespostaSolicitacao: true, erro: false, error_elo: false, mensagem: ''};

        case 'CONCAL_RECEBIDO':
            return {...state, dadosConcal: {...state.dadosConcal, [action.payload.nb]: action.payload.data, nb: action.payload.data}, 
            esperandoRespostaSolicitacao: false, mensagem: '', erro: false};

        case 'CONCAL_ERRO':
            return {...state, mensagem: action.payload, esperandoRespostaSolicitacao: false, erro: true };

        case 'CONCAL_ERRO_ELO':
            return { ...state, esperandoRespostaSolicitacao: false, error_elo: true }
  
        case 'CONCAL_ERRO_LIMPO':
            return {...state, esperandoRespostaSolicitacao: false, mensagem: '', erro: false };

        case 'CONCAL_IMPRESSAO_RECEBIDA':
            return {...state, esperandoRespostaSolicitacao: false, erro: false, mensagem: 'sucesso' };
 
        case 'CONCAL_DADOS_PDF_SOLICITADO':
            return {...state, esperandoRespostaSolicitacao: true, mensagem: ''};
        case 'CONCAL_NAO_ENCONTRADA':
            return {...state, esperandoRespostaSolicitacao: false, erro: false, mensagem: 'not_found' };
        default:
            return state;
    }
}

